
<template>

<div>
 <MenuPantallaStore @update-buscador="buscador = $event"
                     @update-categoria="categoriaSeleccionada = $event"

                      @update-vendedor="vendedorSeleccionado = $event"
 ></MenuPantallaStore> 
  <MenuMovilStore></MenuMovilStore> 
 <CoreViewStore :buscador="buscador" :categoriaSeleccionada="categoriaSeleccionada"
 
 :vendedorSeleccionado="vendedorSeleccionado"
 ></CoreViewStore> 
  <FooterPerfilStore></FooterPerfilStore>

  <!-- FAB + Popover: Mas Sistemas -->
  <v-menu
    v-model="menuSistemas"
    :close-on-content-click="false"
    offset-x
    left
    :nudge-width="260"
    :max-width="300"
  >
    <template v-slot:activator="{ on: menuOn }">
      <v-tooltip left>
        <template v-slot:activator="{ on: tipOn }">
          <v-btn
            v-on="{ ...menuOn, ...tipOn }"
            fab
            dark
            large
            color="#1a73e8"
            :style="{
              position: 'fixed',
              bottom: $vuetify.breakpoint.xs ? '20px' : '30px',
              right: $vuetify.breakpoint.xs ? '20px' : '30px',
              zIndex: 999
            }"
          >
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <span>Más sistemas</span>
      </v-tooltip>
    </template>

    <v-card min-width="220" class="pa-2">
      <v-list-item
        @click="abrirStore"
        style="border-radius: 8px; cursor: pointer;"
        class="mb-1"
      >
        <v-list-item-avatar>
          <v-icon color="#6A76AB" large>mdi-store</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
            TecZoa Store
          </v-list-item-title>
          <v-list-item-subtitle style="font-size: 12px;">
            Productos y servicios.
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon color="grey">mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>

      <v-list-item
        @click="abrirLinksTec"
        style="border-radius: 8px; cursor: pointer;"
        class="mt-1"
      >
        <v-list-item-avatar>
          <v-icon color="#1a73e8" large>mdi-link-variant</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
            Links Tec
          </v-list-item-title>
          <v-list-item-subtitle style="font-size: 12px;">
            Gestor de enlaces y perfiles
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon color="grey">mdi-open-in-new</v-icon>
        </v-list-item-action>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <v-list-item
        @click="abrirLogin"
        style="border-radius: 8px; cursor: pointer;"
      >
        <v-list-item-avatar>
          <v-icon color="#1a73e8" large>mdi-login</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
            Iniciar sesión
          </v-list-item-title>
          <v-list-item-subtitle style="font-size: 12px;">
            Accedé a tu cuenta
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-1"></v-divider>

      <v-list-item
        @click="abrirRegister"
        style="border-radius: 8px; cursor: pointer;"
      >
        <v-list-item-avatar>
          <v-icon color="#43A047" large>mdi-account-plus</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold" style="font-size: 14px;">
            Registrarse
          </v-list-item-title>
          <v-list-item-subtitle style="font-size: 12px;">
            Creá una cuenta nueva
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-menu>

  <LoginTienda v-model="dialogLogin" @cambiar-a-registro="irARegistro" />
  <RegisterTienda v-model="dialogRegister" @cambiar-a-login="irALogin" />
</div>
</template>
<script>


import CoreViewStore from '@/components/common/ViewStore'

import MenuPantallaStore from '@/components/base/MenuPantallaStore.vue'
import MenuMovilStore from '@/components/base/MenuMovilStore.vue'

import PerfilOpciones from '@/components/common/PerfilOpciones.vue';


import FooterPerfilStore from '@/components/common/FooterPerfilStore';

import LoginTienda from '@/components/tienda/usuario/LoginTienda'
import RegisterTienda from '@/components/tienda/usuario/RegisterTienda'

export default {
  name: 'MenuStorePrincipal',

  components: {
    CoreViewStore,
    MenuPantallaStore,
    MenuMovilStore,
        FooterPerfilStore,
        PerfilOpciones,
        LoginTienda,
        RegisterTienda
  },
  data() {
    return {
      buscador: ""  ,
      categoriaSeleccionada: "todos", 
      vendedorSeleccionado: 'all',
      menuSistemas: false,
      dialogLogin: false,
      dialogRegister: false
    };
  },
  methods: {
    abrirStore() {
      this.menuSistemas = false;
      if (this.$route.path !== '/store/all') {
        this.$router.push('/store/all');
      }
    },
    abrirLinksTec() {
      this.menuSistemas = false;
      window.open('/linkstec', '_blank');
    },
    abrirLogin() {
      this.menuSistemas = false;
      this.dialogLogin = true;
    },
    abrirRegister() {
      this.menuSistemas = false;
      this.dialogRegister = true;
    },
    irARegistro() {
      this.dialogLogin = false;
      this.$nextTick(() => { this.dialogRegister = true; });
    },
    irALogin() {
      this.dialogRegister = false;
      this.$nextTick(() => { this.dialogLogin = true; });
    }
  }
};




</script>
